import React, { Component } from "react";

import { Link } from "react-router-dom";

import { connect } from "react-redux";

import Logo from "../assets/images/logo.png";
import Menu from "../assets/svg/menu-light.svg";

import MenuFunc from "./Menu";
import Exercises from "../assets/svg/exercise.svg";

import { Helmet } from "react-helmet";

class Home extends Component {
  state = {
    menuToggled: false,
  };

  setmenuoff = (wot) => {
    this.setState({ menuToggled: wot });
  };

  render() {
    return (
      <div>
        <Helmet>
          <title>BoxFit: Garder la forme, c'est vivre plus longtemps!</title>
          <meta
            name="description"
            content="BoxFit est l'application d'entraînement ultime à domicile
    avec plus de 390 exercices vidéo, 10 catégories d'entraînement différentes et premium,
    des fonctionnalités telles que l'historique d'entraînement et le radar de poids. BoxFit vous prépare à gérer tous les WOD possible en box ou à l'extérieur."
          />

          <meta property="og:url" content="https://boxfit-fitness.com" />
          <meta property="og:title" content="BoxFit" />
          <meta
            property="og:description"
            content="BoxFit est l'application d'entraînement ultime à domicile
    avec plus de 390 exercices vidéo, 10 catégories d'entraînement différentes et premium,
    des fonctionnalités telles que l'historique d'entraînement et le radar de poids. BoxFit vous prépare à gérer tous les WOD possible en box ou à l'extérieur."
          />
          <meta property="og:site_name" content="BoxFit" />
          <meta
            property="og:image"
            content="https://fitzet.com/images/sharer.png"
          />
          <meta property="og:type" content="profile" />
          <meta property="og:locale" content="en_US" />
        </Helmet>
        <div class="header" style={{ position: "relative" }}>
          <MenuFunc display={this.state.menuToggled} off={this.setmenuoff} />

          <div
            style={{
              zIndex: 999,
              position: "absolute",
              top: "15px",
              left: "20px",
            }}
          >
            <Link
              to={{
                pathname: "/",
                query: {
                  fromMenu: true,
                },
              }}
            >
              <img src={Logo} alt="logo" style={{ maxHeight: "45px" }}></img>
            </Link>
          </div>

          <div
            style={{
              position: "absolute",
              top: "25px",
              right: "22px",
              zIndex: 999,
            }}
            onClick={() => {
              this.setmenuoff(true);
            }}
          >
            <img src={Menu} alt="logo" style={{ maxHeight: "25px" }}></img>
          </div>
        </div>

        <div
          className="Screen"
          style={{
            /* height: "800px",
            width: "450px",*/
            borderRadius: "20px",
            /*boxShadow: "2px 2px 120px rgba(255, 255, 255, 0.15)",*/
            /*backgroundColor: "#000",*/
          }}
        >
          <div style={{ padding: "60px 20px 20px 20px" }}>
            <div style={{ display: "flex", textAlign: "center" }}>
              <div
                className="notmobile2"
                style={{ alignSelf: "center", textAlign: "left" }}
              >
                <h2 style={{ color: "#69C9D0" }}>
                  Restez en forme. Vivez plus longtemps
                  <img
                    src={Exercises}
                    style={{
                      maxWidth: "30px",
                      opacity: 0.65,
                    }}
                    alt="Workouts"
                    className="formob"
                  />
                </h2>

                <h3 style={{ fontWeight: "400" }}>
                  <strong>BoxFit</strong> est l'application d'entraînement ultime à domicile avec plus de <strong>390</strong> exercices vidéo,{" "}
                  <strong>10</strong> catégories d'entraînement différentes et premium, des fonctionnalités telles que l'historique d'entraînement et le radar de poids. BoxFit vous prépare à gérer tous les WOD possibles en box ou à l'extérieur. 
                </h3>
              </div>
            </div>

            <h2 style={{ color: "#EE1D52" }}>Facile à utiliser</h2>

            <h3 style={{ fontWeight: "400" }}>
              <strong>BoxFit</strong>  est l'application web d'entraînement ultime qui ne vous oblige pas à télécharger une appli sur votre mobile. <strong>BoxFit</strong> peut être directement utilisé sur votre navigateur web.
            </h3>

            <div style={{ height: "10px" }}></div>
            <h2 style={{ color: "#69C9D0" }}>Pour tout le monde</h2>

            <h3 style={{ fontWeight: "400" }}>
              <strong>BoxFit</strong> compte 390 exercices and 10
              Catégories différentes d'exercices{" "}
              <Link style={{ color: "white" }} to="/start-workout/cardio">
                Cardio
              </Link>
              ,{" "}
              <Link style={{ color: "white" }} to="/start-workout/abs">
                Abdos
              </Link>{" "}
              and{" "}
              <Link style={{ color: "white" }} to="/start-workout/arm">
                Bras
              </Link>
              .
            </h3>
            <div style={{ height: "10px" }}></div>

            <h2 style={{ color: "#EE1D52" }}>Commencer maintenant</h2>

            <h3 style={{ fontWeight: "400" }}>
              Vous êtes prêts! Vous allez commencer votre entraînement à la maison avec BoxFit,
              cliquez sur le bouton ci-dessous et commencez votre session. 
            </h3>
            <div style={{ height: "10px" }}></div>

            <p>
              <button
                style={{
                  background: "#69C9D0",
                  padding: "10px",
                  border: 0,
                  borderRadius: "4px",
                  fontWeight: "600",
                  width: "100%",
                  color: "white",
                  fontSize: "1.2rem",
                }}
                onClick={() => {
                  this.props.history.push({
                    pathname: "/select-workout",
                  });
                }}
              >
                Commencer entraînement{" "}
                <span role="img" aria-label="like">
                  🔥
                </span>
              </button>
            </p>
            <div style={{ height: "60px" }}></div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(Home);
